"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LotDetailsTab = void 0;
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var material_1 = require("@mui/material");
var react_router_dom_1 = require("react-router-dom");
var functions_1 = require("../../../constants/functions");
var extra_data_1 = require("../../../controls/extra_data/extra_data");
var doshx_controls_web_1 = require("doshx_controls_web");
var main_1 = require("../../../reducers/slices/main");
var moment_timezone_1 = __importDefault(require("moment-timezone"));
var get_lot_1 = require("../../../api/calls/lot/v3/get_lot");
var create_lot_1 = require("../../../api/calls/lot/v3/create_lot");
var update_lot_1 = require("../../../api/calls/lot/v3/update_lot");
var textarea_1 = require("../../../controls/textarea/textarea");
var upload_1 = require("../../../api/calls/file/upload");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var delete_1 = require("../../../api/calls/file/delete");
var pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
var react_toastify_1 = require("react-toastify");
var heic2any_1 = __importDefault(require("heic2any"));
var AddressSearchControl_1 = require("../../../components/AddressSearchControl");
var LotDetailsTab = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
    var lot_id = props.lot_id, onSave = props.onSave;
    var lotTypes = ["Collectables", "Collector Cars", "Livestock", "Machinery", "Real Estate", "Vehicles/Trucks"];
    var lotStatuses = ["Bidding Closed", "Bidding Open", "Sold", "Passed", "Withdrawn", "Subject to Confirm", "Reserve Not reached"];
    // Subject to Confirm
    // Reserve Not reached
    var dispatch = (0, react_redux_1.useDispatch)();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var _t = (0, react_1.useState)(false), isSaving = _t[0], setIsSaving = _t[1];
    var _u = (0, react_1.useState)(false), noReserve = _u[0], setNoReserve = _u[1];
    var _v = (0, react_1.useState)(""), amount = _v[0], setAmount = _v[1];
    var _w = (0, react_1.useState)(""), dateError = _w[0], setDateError = _w[1];
    // const { lots, selectedLot, isEditing } = useSelector<any, any>((state) => state.lotState);
    var _x = (0, react_1.useState)({
        title: "",
        broker_name: "",
        other_info: "lot_broker_image",
        broker_image: "",
        description: "",
        starting_price: "",
        buyerCommission: "",
        sellerCommission: "",
        vat: "",
        ancillaryCost: "",
        vatExclusive: false,
        // date_from:"",
        // date_to:"",
        reserve_price: "",
        vendor_bidding: {
            enabled: false,
            bid_increment: "",
            bid_limit: "",
            timeout: 0,
        },
        isAutoBidEnable: false,
        autoBidMinAmt: "",
        // vat: "",
        // buyer_commission: "",
        // seller_commission: "",
        contacts: {
            email: "",
            phone: {
                country_code: "ZA",
                calling_code: "+27",
                number: "",
            },
            whatsapp: {
                country_code: "ZA",
                calling_code: "+27",
                number: "",
            },
        },
        location: null,
        // status: "Bidding Closed",
        extra_data: [],
        youtube_url: "",
    }), lot = _x[0], setLot = _x[1];
    var mainAuction = (0, react_redux_1.useSelector)(function (state) { return state.consoleState; }).mainAuction;
    var selectedClient = (0, react_redux_1.useSelector)(function (state) { return state.clientState; }).selectedClient;
    (0, react_1.useEffect)(function () {
        if (lot) {
            loadExtraData();
        }
    }, [lot]);
    (0, react_1.useEffect)(function () {
        if (lot_id) {
            // Editing
            (0, get_lot_1.get_lot)({
                entity_id: lot_id,
            }).then(function (response) {
                var _a, _b;
                if (response.data.success) {
                    var lotData = response.data.content;
                    // console.log("lotData", lotData);
                    if (!(lotData === null || lotData === void 0 ? void 0 : lotData.contacts)) {
                        lotData.contacts = {};
                    }
                    if (!((_a = lotData === null || lotData === void 0 ? void 0 : lotData.contacts.phone) === null || _a === void 0 ? void 0 : _a.number)) {
                        lotData.contacts.phone = {
                            country_code: "ZA",
                            calling_code: "+27",
                            number: "",
                        };
                    }
                    if (!((_b = lotData === null || lotData === void 0 ? void 0 : lotData.contacts.whatsapp) === null || _b === void 0 ? void 0 : _b.number)) {
                        lotData.contacts.whatsapp = {
                            country_code: "ZA",
                            calling_code: "+27",
                            number: "",
                        };
                    }
                    setLot(lotData);
                    // setLot({
                    //   ...lotData,
                    //   date_from: lotData.date_from ? moment(lotData.date_from).tz("Africa/Johannesburg") : null,
                    //   date_to: lotData.date_to ? moment(lotData.date_to).tz("Africa/Johannesburg") : null
                    // });
                }
                else {
                    dispatch((0, main_1.setMessageModal)({ title: "Something went wrong!", messages: [response.data.message] }));
                }
            });
        }
        else {
            // Creating
            setLot(__assign(__assign({}, lot), { automated: {
                    enabled: true,
                }, status: "Bidding Closed", date_from: (0, moment_timezone_1.default)().tz("Africa/Johannesburg"), date_to: (0, moment_timezone_1.default)().tz("Africa/Johannesburg") }));
        }
    }, [lot_id]);
    var _y = (0, react_1.useState)([]), extraData = _y[0], setExtraData = _y[1];
    var fieldChanged = function (name, value) {
        var _a;
        setLot(__assign(__assign({}, lot), (_a = {}, _a[name] = value, _a)));
    };
    var loadExtraData = function () {
        if (lot.extra_data) {
            var ed = [];
            for (var _i = 0, _a = lot.extra_data; _i < _a.length; _i++) {
                var d = _a[_i];
                ed.push({ key: d.key, value: d.value });
            }
            setExtraData(ed);
        }
    };
    var validate = function () {
        var _a;
        var messages = [];
        // if (fields.is_popular) {
        //   messages.push("Is Popular is required.");
        // }
        if (lot.title.length == 0) {
            messages.push("Title is required.");
        }
        if ((_a = lot === null || lot === void 0 ? void 0 : lot.contacts) === null || _a === void 0 ? void 0 : _a.email) {
            var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(lot.contacts.email)) {
                messages.push("Please enter a valid email address.");
            }
        }
        else {
            messages.push("Email address is required.");
        }
        if (lot.description.length == 0) {
            messages.push("Description is required.");
        }
        // if (fields.starting_price.length == 0) {
        //   messages.push("Starting price is required.");
        // }
        // date_from / date_to validation skipped for update — backend does not accept these fields
        // if (!lot.date_from) {
        //   messages.push("Date From is required.");
        // }
        // if (!lot.date_to) {
        //   messages.push("Date To is required.");
        // } else {
        //   const dateValidation = validateDates(lot.date_from, lot.date_to);
        //   if (dateValidation) {
        //     messages.push(dateValidation);
        //   }
        // }
        if (lot.status == null) {
            messages.push("Status is required.");
        }
        // if (lot.buyerCommission === "" || lot.buyerCommission == null) {
        //   messages.push("Buyer Commission is required.");
        // } else if (isNaN(lot.buyerCommission) || parseFloat(lot.buyerCommission) < 0 || parseFloat(lot.buyerCommission) > 100) {
        //   messages.push("Buyer Commission must be between 0% and 100%.");
        // }
        // if (lot.sellerCommission === "" || lot.sellerCommission == null) {
        //   messages.push("Seller Commission is required.");
        // } else if (isNaN(lot.sellerCommission) || parseFloat(lot.sellerCommission) < 0 || parseFloat(lot.sellerCommission) > 100) {
        //   messages.push("Seller Commission must be between 0% and 100%.");
        // }
        // if (lot.vat === "" || lot.vat == null) {
        //   messages.push("VAT is required.");
        // } else if (isNaN(lot.vat) || parseFloat(lot.vat) < 0 || parseFloat(lot.vat) > 100) {
        //   messages.push("VAT must be between 0% and 100%.");
        // }
        // if (lot.ancillaryCost === "" || lot.ancillaryCost == null) {
        //   messages.push("Ancillary Cost is required.");
        // } else if (isNaN(lot.ancillaryCost) || parseFloat(lot.ancillaryCost) <= 0) {
        //   messages.push("Ancillary Cost must be greater than 0.");
        // } else if (lot.reserve_price && !isNaN(parseFloat(lot.reserve_price)) && parseFloat(lot.ancillaryCost) >= parseFloat(lot.reserve_price)) {
        //   messages.push("Ancillary Cost must be less than the Reserve Price.");
        // }
        // if (lot.ancillaryCost === "" || lot.ancillaryCost == null) {
        //   messages.push("Ancillary Cost is required.");
        // } else if (isNaN(lot.ancillaryCost) || parseFloat(lot.ancillaryCost) < 0) {
        //   messages.push("Ancillary Cost must be greater than or equal to 0.");
        // } else if (lot.reserve_price && !isNaN(parseFloat(lot.reserve_price)) && parseFloat(lot.ancillaryCost) >= parseFloat(lot.reserve_price)) {
        //   messages.push("Ancillary Cost must be less than the Reserve Price.");
        // }
        if (lot.vendor_bidding && lot.vendor_bidding.enabled) {
            var _b = lot.vendor_bidding, bid_increment = _b.bid_increment, bid_limit = _b.bid_limit, timeout = _b.timeout;
            if (!bid_increment) {
                messages.push("Bid Increment is required.");
            }
            else {
                if (parseFloat(bid_increment) <= 0) {
                    messages.push("Bid Increment must be greater than 0.");
                }
            }
            if (!bid_limit) {
                messages.push("Bid Limit is required.");
            }
            else {
                if (parseFloat(bid_limit) <= 0) {
                    messages.push("Bid Limit must be greater than 0.");
                }
            }
            // moment from minutes to seconds
            if (moment_timezone_1.default.duration(timeout, "seconds").asMinutes() < 1) {
                messages.push("Timeout must be at least 1 minute.");
            }
            // bid amount must be < bid limit
            if (parseFloat(bid_increment) > parseFloat(bid_limit)) {
                messages.push("The Bid Increment must be less than or equal to the Bid Limit.");
            }
        }
        // if (fields.type == null) {
        //   messages.push("Type is required.");
        // }
        if (extraData.length > 0) {
            //Check that all extra data have been assigned.
            for (var _i = 0, extraData_1 = extraData; _i < extraData_1.length; _i++) {
                var ed = extraData_1[_i];
                var index = extraData.indexOf(ed);
                if (!ed.key || !ed.value) {
                    messages.push("You did not fill in all fields for the ".concat((0, functions_1.toOrdinalSuffix)(index + 1), " data entry."));
                }
            }
        }
        if (messages && messages.length > 0) {
            dispatch((0, main_1.setMessageModal)({ title: "Validation failed!", messages: messages }));
            return false;
        }
        else {
            return true;
        }
    };
    var _z = (0, react_1.useState)(null), brokerImage = _z[0], setBrokerImage = _z[1];
    var _0 = (0, react_1.useState)(null), image = _0[0], setImage = _0[1];
    var fileInputRef = (0, react_1.useRef)(null);
    var _1 = (0, react_1.useState)([]), files = _1[0], setFiles = _1[1];
    var _2 = (0, react_1.useState)(""), liftPrice = _2[0], setLiftPrice = _2[1];
    var _3 = (0, react_1.useState)(false), isFocused = _3[0], setIsFocused = _3[1];
    var _4 = (0, react_1.useState)(lot.reserve_price), lastReservePrice = _4[0], setLastReservePrice = _4[1];
    (0, react_1.useEffect)(function () {
        var err = validateDates(lot.date_from, lot.date_to);
        setDateError(err || "");
    }, [lot.date_from, lot.date_to]);
    var validateDates = function (date_from, date_to) {
        // console.log("date_from", date_from);
        // console.log("date_to", date_to);
        if (!date_to || !date_from) {
            return "";
        }
        if ((0, moment_timezone_1.default)(date_to).isSameOrBefore((0, moment_timezone_1.default)(date_from))) {
            return "Date To must be greater than Date From.";
        }
        // Check if date_to is less than date_from
        if (date_to <= date_from) {
            return "Date To must be greater than Date From.";
        }
        // Calculate the time difference in minutes
        // console.log("date_to", date_to);
        // console.log("date_from", date_from);
        var differenceInMinutes = (date_to - date_from) / (1000 * 60);
        //     console.log("differenceInMinutes", differenceInMinutes);
        // Check if the difference is less than 2 minutes
        if (differenceInMinutes < 2) {
            return "The time difference must be 2 minutes or more.";
        }
    };
    // Load existing image when component mounts or lot data changes
    (0, react_1.useEffect)(function () {
        var _a, _b;
        if ((_b = (_a = lot === null || lot === void 0 ? void 0 : lot.broker_images) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.uploaded_file_url) {
            setImage(lot.broker_images[0].uploaded_file_url);
        }
    }, [lot]);
    // const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    //   const file = e.target.files?.[0];
    //   if (file) {
    //     setBrokerImage(file);
    //     setImage(URL.createObjectURL(file));
    //   }
    // };
    var handleImageChange = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var file, processedFile, convertedBlob, err_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    file = (_a = e.target.files) === null || _a === void 0 ? void 0 : _a[0];
                    if (!file) return [3 /*break*/, 5];
                    processedFile = file;
                    if (!(file.name.toLowerCase().endsWith(".heic") || file.type === "image/heic")) return [3 /*break*/, 4];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, (0, heic2any_1.default)({
                            blob: file,
                            toType: "image/jpeg",
                            quality: 0.8,
                        })];
                case 2:
                    convertedBlob = (_b.sent());
                    processedFile = new File([convertedBlob], file.name.replace(/\.heic$/i, ".jpg"), {
                        type: "image/jpeg",
                        lastModified: file.lastModified,
                    });
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _b.sent();
                    return [3 /*break*/, 4];
                case 4:
                    setBrokerImage(processedFile);
                    setImage(URL.createObjectURL(processedFile));
                    _b.label = 5;
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleRemoveImage = function (e) {
        e.stopPropagation();
        setBrokerImage(null);
        setImage(null);
        if (fileInputRef.current)
            fileInputRef.current.value = "";
    };
    var deleteFile = function (file_id) { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!file_id)
                        return [2 /*return*/];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, (0, delete_1.delete_file)({ file_entity_id: file_id })];
                case 2:
                    response = _a.sent();
                    if (response.data.success) {
                        setImage(null);
                        setBrokerImage(null);
                        if (fileInputRef.current)
                            fileInputRef.current.value = "";
                        react_toastify_1.toast.success("Image deleted successfully");
                    }
                    else {
                        react_toastify_1.toast.error(response.data.message || "Failed to delete image");
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    //       console.error("Error deleting image:", error);
                    react_toastify_1.toast.error("Error deleting image");
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var formatWithSpaces = function (value) {
        return value
            .toString()
            .replace(/\D/g, "") // remove all non-digits
            .replace(/\B(?=(\d{3})+(?!\d))/g, " "); // add space every 3 digits
    };
    var unformat = function (value) {
        var raw = value.replace(/\s/g, ""); // remove spaces
        var num = parseFloat(raw);
        return isNaN(num) ? null : num;
    };
    var cleanDateFrom = (0, moment_timezone_1.default)(lot.date_from).seconds(0).milliseconds(0);
    var cleanDateTo = (0, moment_timezone_1.default)(lot.date_to).seconds(0).milliseconds(0);
    return (react_1.default.createElement("div", { className: "flex flex-col w-full" }, lot ? (react_1.default.createElement("div", { className: "flex flex-col space-y-4 p-4 w-full" },
        react_1.default.createElement("div", { className: "flex flex-row gap-4 justify-start" }, lot.entity_id ? (react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Update Details", 
            // theme="blue"
            size: "small", loading: isSaving, backgroundColor: "bg-green-500", onClick: function () {
                if (validate()) {
                    var request = {
                        // ...lot,
                        title: lot.title,
                        // broker_name: lot.broker_name,
                        // other_info: "lot broker image",
                        description: lot.description,
                        // date_from and date_to are not sent on update — backend rejects them
                        // date_from: lot.date_from,
                        // date_to: lot.date_to,
                        // buyerCommission: lot.buyerCommission,
                        // sellerCommission: lot.sellerCommission,
                        // vat: lot.vat,
                        // ancillaryCost: lot.ancillaryCost,
                        // vatExclusive: lot.vatExclusive,
                        starting_price: lot.starting_price,
                        reserve_price: lot.reserve_price,
                        vendor_bidding: lot.vendor_bidding,
                        // autoBidMinAmt: lot.autoBidMinAmt,
                        // autoBidMinAmt: lot.isAutoBidEnable ? lot.autoBidMinAmt : 0,
                        // isAutoBidEnable: lot.isAutoBidEnable,
                        status: lot.status,
                        extra_data: extraData,
                        youtube_url: lot.youtube_url,
                        location: lot.location,
                        contacts: lot === null || lot === void 0 ? void 0 : lot.contacts,
                        // automated: lot.automated,
                        // vat: lot.vat,
                        // seller_commission: lot.seller_commission,
                        // buyer_commission: lot.buyer_commission,
                    };
                    setIsSaving(true);
                    (0, update_lot_1.update_lot)({
                        entity_id: lot.entity_id,
                        entity: request,
                    }).then(function (response) {
                        var _a, _b;
                        setIsSaving(false);
                        var lot_entity_id = (_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.content) === null || _b === void 0 ? void 0 : _b.entity_id;
                        // console.log(lot_entity_id, "Created Lot");
                        if (response.data.success) {
                            if (brokerImage) {
                                (0, upload_1.upload_file)({
                                    lot_id: lot_entity_id,
                                    type: "Image",
                                    file: brokerImage,
                                    other_info: "lot_broker_image",
                                });
                            }
                            // navigate("/console/lots");
                            dispatch((0, main_1.setMessageModal)({
                                title: "Success!",
                                messages: [lot_id ? "Lot updated successfully." : "Lot created successfully."],
                            }));
                            onSave(response.data.content);
                        }
                        else {
                            dispatch((0, main_1.setMessageModal)({ title: "Something went wrong!", messages: [response.data.message] }));
                        }
                    });
                }
            } })) : (react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Create Lot", 
            // theme="blue"
            size: "small", loading: isSaving, backgroundColor: "bg-green-500", onClick: function () {
                if (validate()) {
                    var request = {
                        // ...lot,
                        title: lot.title,
                        // broker_name: lot.broker_name,
                        // other_info: "lot broker image",
                        description: lot.description,
                        // date_from and date_to not sent — backend rejects them
                        // date_from: lot.date_from,
                        // date_to: lot.date_to,
                        // buyerCommission: lot.buyerCommission,
                        // sellerCommission: lot.sellerCommission,
                        // vat: lot.vat,
                        // ancillaryCost: lot.ancillaryCost,
                        // vatExclusive: lot.vatExclusive,
                        starting_price: lot.starting_price,
                        reserve_price: lot.reserve_price,
                        vendor_bidding: lot.vendor_bidding,
                        // isAutoBidEnable: lot.isAutoBidEnable,
                        // autoBidMinAmt: lot.autoBidMinAmt,
                        // autoBidMinAmt: lot.isAutoBidEnable ? lot.autoBidMinAmt : 0,
                        auction_entity_id: mainAuction.entity_id,
                        status: lot.status,
                        extra_data: extraData,
                        youtube_url: lot.youtube_url,
                        location: lot.location,
                        contacts: lot === null || lot === void 0 ? void 0 : lot.contacts,
                        // vat: lot.vat,
                        // seller_commission: lot.seller_commission,
                        // buyer_commission: lot.buyer_commission,
                        // automated: {
                        //   enabled: lot.automated?.soft_closing?.enabled || false,
                        //   soft_closing: {
                        //     enabled: lot.automated?.soft_closing?.enabled ?? false,
                        //     timeout: lot.automated?.soft_closing?.timeout,
                        //   },
                        // },
                        // _id: lot_id,
                    };
                    setIsSaving(true);
                    (0, create_lot_1.create_lot)(request).then(function (response) {
                        var _a, _b;
                        setIsSaving(false);
                        var lot_entity_id = (_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.content) === null || _b === void 0 ? void 0 : _b.entity_id;
                        // console.log(lot_entity_id, "Created Lot");
                        if (response.data.success) {
                            // Upload broker image if it exists
                            if (brokerImage) {
                                (0, upload_1.upload_file)({
                                    lot_id: lot_entity_id,
                                    type: "Image",
                                    file: brokerImage,
                                    other_info: "lot_broker_image",
                                });
                            }
                            // navigate("/console/lots");
                            dispatch((0, main_1.setMessageModal)({
                                title: "Success!",
                                messages: [lot_id ? "Lot updated successfully." : "Lot created successfully."],
                            }));
                            onSave(response.data.content);
                        }
                        else {
                            dispatch((0, main_1.setMessageModal)({ title: "Something went wrong!", messages: [response.data.message] }));
                        }
                    });
                }
            } }))),
        react_1.default.createElement("div", { className: "flex flex-col gap-4 bg-[#3fcb721f] px-6 py-6 rounded-lg" },
            react_1.default.createElement("div", { className: "width-full flex items-center gap-4 border-4 border-dashed ".concat(image ? "border-green-500" : "border-black", " text-black text-2xl w-full rounded-xl p-4 cursor-pointer text-center hover:underline relative"), onClick: function () { var _a; return !image && ((_a = fileInputRef.current) === null || _a === void 0 ? void 0 : _a.click()); } },
                react_1.default.createElement("div", { className: "w-2/3 mb-4 pointer-events-none" },
                    react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Broker Image", value: "Please Upload Broker Image", disabled: true, onChange: function (v) { return fieldChanged("title", v); } })),
                image ? (react_1.default.createElement("div", { className: "w-1/3 pointer-events-none" },
                    " ",
                    react_1.default.createElement("div", { className: "w-full" },
                        react_1.default.createElement("img", { src: image, alt: "Broker preview", className: "object-cover w-full h-full mb-2" }),
                        !brokerImage && ((_b = (_a = lot === null || lot === void 0 ? void 0 : lot.broker_images) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.entity_id) && (react_1.default.createElement("div", { className: "w-8 h-8 rounded-full bg-red-500 text-white text-sm absolute \n                        top-2 right-2 flex justify-center items-center cursor-pointer\n                         shadow-[0_0px_10px_0px_rgba(0,0,0,0.3)] z-10 pointer-events-auto", onClick: function (e) {
                                e.stopPropagation();
                                deleteFile(lot.broker_images[0].entity_id);
                            } },
                            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faTimes }))),
                        brokerImage && (react_1.default.createElement("div", { className: "w-8 h-8 rounded-full bg-red-500 text-white text-sm absolute \n                      top-0 right-0 flex justify-center items-center cursor-pointer\n                       shadow-[0_0px_10px_0px_rgba(0,0,0,0.3)] z-10 pointer-events-auto", onClick: handleRemoveImage },
                            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faTimes })))))) : (react_1.default.createElement("span", null)),
                react_1.default.createElement("input", { type: "file", accept: "image/*", ref: fileInputRef, onChange: handleImageChange, className: "hidden", multiple: false }))),
        react_1.default.createElement("div", { className: "w-full" },
            react_1.default.createElement("div", { className: "flex gap-4 w-full" },
                react_1.default.createElement("div", { className: "flex-1" },
                    react_1.default.createElement(material_1.TextField, { label: "Email address", value: ((_c = lot === null || lot === void 0 ? void 0 : lot.contacts) === null || _c === void 0 ? void 0 : _c.email) || "", onChange: function (e) { return fieldChanged("contacts", __assign(__assign({}, lot === null || lot === void 0 ? void 0 : lot.contacts), { email: e.target.value })); }, InputLabelProps: { shrink: true }, sx: {
                            width: "100%",
                            "& .MuiOutlinedInput-root": {
                                borderRadius: "0.75rem",
                                "& fieldset": {
                                    borderColor: "black",
                                },
                                "&:hover fieldset": {
                                    borderColor: "black",
                                },
                                "&.Mui-focused fieldset": {
                                    borderColor: "black",
                                },
                            },
                            "& .MuiInputLabel-root": {
                                color: "black",
                            },
                            "& .MuiInputLabel-root.Mui-focused": {
                                color: "black",
                            },
                            "& .MuiInputBase-input": {
                                color: "black",
                            },
                        } })),
                react_1.default.createElement("div", { className: "flex-1" },
                    react_1.default.createElement(doshx_controls_web_1.PhoneInputControl, { label: "Whatsapp number", value: (_f = (_e = (_d = lot === null || lot === void 0 ? void 0 : lot.contacts) === null || _d === void 0 ? void 0 : _d.whatsapp) === null || _e === void 0 ? void 0 : _e.number) !== null && _f !== void 0 ? _f : "", defaultCountryCode: "ZA", countryCodeValue: (_h = (_g = lot === null || lot === void 0 ? void 0 : lot.contacts) === null || _g === void 0 ? void 0 : _g.whatsapp) === null || _h === void 0 ? void 0 : _h.country_code, size: "medium", onChange: function (v) {
                            var _a;
                            setLot(__assign(__assign({}, lot), { contacts: __assign(__assign({}, lot === null || lot === void 0 ? void 0 : lot.contacts), { whatsapp: __assign(__assign({}, (_a = lot === null || lot === void 0 ? void 0 : lot.contacts) === null || _a === void 0 ? void 0 : _a.whatsapp), { number: v }) }) }));
                        }, onExtensionChange: function (ext, cc) {
                            var _a;
                            setLot(__assign(__assign({}, lot), { contacts: __assign(__assign({}, lot === null || lot === void 0 ? void 0 : lot.contacts), { whatsapp: __assign(__assign({}, (_a = lot === null || lot === void 0 ? void 0 : lot.contacts) === null || _a === void 0 ? void 0 : _a.whatsapp), { country_code: cc, calling_code: ext }) }) }));
                        } })),
                react_1.default.createElement("div", { className: "flex-1" },
                    react_1.default.createElement(doshx_controls_web_1.PhoneInputControl, { label: "Phone number", value: (_l = (_k = (_j = lot === null || lot === void 0 ? void 0 : lot.contacts) === null || _j === void 0 ? void 0 : _j.phone) === null || _k === void 0 ? void 0 : _k.number) !== null && _l !== void 0 ? _l : "", defaultCountryCode: "ZA", countryCodeValue: (_o = (_m = lot === null || lot === void 0 ? void 0 : lot.contacts) === null || _m === void 0 ? void 0 : _m.phone) === null || _o === void 0 ? void 0 : _o.country_code, size: "medium", onChange: function (v) {
                            var _a;
                            setLot(__assign(__assign({}, lot), { contacts: __assign(__assign({}, lot === null || lot === void 0 ? void 0 : lot.contacts), { phone: __assign(__assign({}, (_a = lot === null || lot === void 0 ? void 0 : lot.contacts) === null || _a === void 0 ? void 0 : _a.phone), { number: v }) }) }));
                        }, onExtensionChange: function (ext, cc) {
                            var _a;
                            var qwe = __assign(__assign({}, lot), { contacts: __assign(__assign({}, lot === null || lot === void 0 ? void 0 : lot.contacts), { phone: __assign(__assign({}, (_a = lot === null || lot === void 0 ? void 0 : lot.contacts) === null || _a === void 0 ? void 0 : _a.phone), { country_code: cc, calling_code: ext }) }) });
                            // console.log("onExtensionChange", qwe);
                            setLot(qwe);
                        } })))),
        react_1.default.createElement("div", { className: "flex gap-4" }),
        react_1.default.createElement("div", { className: "flex flex-col px-6 py-6 gap-4 bg-[#CC550012] rounded-lg" },
            react_1.default.createElement("div", { className: "flex flex-col gap-4" },
                react_1.default.createElement("div", { className: "flex gap-4" },
                    react_1.default.createElement("div", { className: "flex gap-4 w-full" },
                        react_1.default.createElement("div", { className: "w-1/4" },
                            react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Title", value: lot.title, onChange: function (v) { return fieldChanged("title", v); } })),
                        react_1.default.createElement("div", { className: "w-1/4" },
                            react_1.default.createElement(doshx_controls_web_1.NewDropdownControl, { label: "Status", value: lot.status, renderDisplay: function (v) { return v; }, options: lotStatuses, onChange: function (v) {
                                    // console.log(v);
                                    fieldChanged("status", v);
                                }, colors: {
                                    labelColor: "text-black",
                                    borderColor: "border-black",
                                } })),
                        react_1.default.createElement("div", { className: "w-1/4" },
                            react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Starting Price", type: "text" // use text so formatting doesn't break input
                                , value: ((_p = lot.starting_price) === null || _p === void 0 ? void 0 : _p.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")) || "", onChange: function (v) {
                                    // Remove all non-digit characters before saving
                                    var rawValue = v.replace(/\D/g, "");
                                    if (!isNaN(rawValue) && Number(rawValue) >= 0) {
                                        fieldChanged("starting_price", Number(rawValue));
                                    }
                                } })),
                        react_1.default.createElement("div", { className: "flex items-center w-1/4 px-2 justify-between border border-black rounded-lg gap-2 min-h-[52px]" }, noReserve ? (react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement("span", { className: "text-sm" }, "No Reserve"),
                            react_1.default.createElement(doshx_controls_web_1.SwitchControl, { label: "", onChange: function (v) {
                                    setNoReserve(v);
                                    if (v) {
                                        // Store current price before clearing
                                        setLastReservePrice(lot.reserve_price);
                                        fieldChanged("reserve_price", null);
                                    }
                                    else {
                                        // Restore the stored price when toggled off
                                        fieldChanged("reserve_price", lastReservePrice || 0);
                                    }
                                }, checked: noReserve }))) : (react_1.default.createElement("div", { className: "relative w-full" },
                            react_1.default.createElement("label", { className: "absolute left-3 transition-all duration-200 pointer-events-none ".concat(lot.reserve_price || isFocused ? "text-xs -top-2 px-1 bg-white text-gray-500" : "text-sm top-3 text-gray-400") }, "Reserve Price"),
                            react_1.default.createElement("input", { type: "text", value: lot.reserve_price !== null && lot.reserve_price !== undefined ? formatWithSpaces(lot.reserve_price) : "", onChange: function (e) {
                                    var raw = e.target.value;
                                    var unformatted = unformat(raw);
                                    if (raw === "") {
                                        fieldChanged("reserve_price", null);
                                        setLastReservePrice(null);
                                    }
                                    else if (unformatted !== null && unformatted >= 0) {
                                        fieldChanged("reserve_price", unformatted);
                                        setLastReservePrice(unformatted);
                                    }
                                    if (noReserve)
                                        setNoReserve(false);
                                }, onFocus: function () { return setIsFocused(true); }, onBlur: function () { return setIsFocused(false); }, placeholder: "Reserve Price", className: "w-full border border-transparent rounded-xl px-3 py-3 pr-16 bg-transparent text-black placeholder-transparent focus:outline-none" }),
                            react_1.default.createElement("div", { className: "absolute right-2 top-1/2 -translate-y-1/2" },
                                react_1.default.createElement(doshx_controls_web_1.SwitchControl, { label: "", checked: noReserve, onChange: function (v) {
                                        setLastReservePrice(lot.reserve_price);
                                        setNoReserve(v);
                                        if (v) {
                                            fieldChanged("reserve_price", lastReservePrice !== null && lastReservePrice !== void 0 ? lastReservePrice : 0);
                                        }
                                    } }))))))),
                react_1.default.createElement("div", { className: "flex w-full" },
                    react_1.default.createElement("div", { className: "w-full" },
                        react_1.default.createElement(textarea_1.TextAreaControl, { label: "Description", lines: 6, value: lot.description, onChange: function (v) { return fieldChanged("description", v); } }))),
                react_1.default.createElement("div", { className: "flex w-full gap-4" },
                    react_1.default.createElement("div", { className: "flex-1 gap-4" },
                        react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Lot Youtube URL", value: lot.youtube_url, onChange: function (v) { return fieldChanged("youtube_url", v); } })),
                    react_1.default.createElement("div", { className: "flex-1 gap-4" },
                        react_1.default.createElement(AddressSearchControl_1.AddressSearchControl, { label: "Location (Search Address)", placeholder: "Search for an address", value: {
                                fullAddress: (_q = lot === null || lot === void 0 ? void 0 : lot.location) === null || _q === void 0 ? void 0 : _q.full_address,
                                coordinates: {
                                    lat: (_r = lot === null || lot === void 0 ? void 0 : lot.location) === null || _r === void 0 ? void 0 : _r.latitude,
                                    lng: (_s = lot === null || lot === void 0 ? void 0 : lot.location) === null || _s === void 0 ? void 0 : _s.longitude,
                                },
                            }, onSelectionChange: function (address) {
                                // console.log("address", address);
                                fieldChanged("location", {
                                    full_address: address.fullAddress,
                                    latitude: address.coordinates.lat,
                                    longitude: address.coordinates.lng,
                                });
                            }, labelColor: "text-black", textColor: "text-black", backgroundColor: "#CC550012" })))),
            react_1.default.createElement("div", null,
                react_1.default.createElement(extra_data_1.ExtraDataControl, { title: "Extra Data", extra_data: extraData, 
                    // isLoading={isImagesLoading}
                    onChange: function (ed) {
                        // console.log("ed", ed);
                        setExtraData(__spreadArray([], ed, true));
                    } }))))) : (react_1.default.createElement("div", { className: "" },
        react_1.default.createElement(doshx_controls_web_1.CircularLoaderControl, { size: "large" })))));
};
exports.LotDetailsTab = LotDetailsTab;
